import { render, staticRenderFns } from "./AlarmShowDialog.vue?vue&type=template&id=21cefcc8&"
import script from "./AlarmShowDialog.vue?vue&type=script&lang=js&"
export * from "./AlarmShowDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports